export default "__VITE_ASSET__dbyI$rzC__"